import { LoadingOverlay, MantineProvider } from '@mantine/core';
import React, {useCallback, useEffect, useState} from "react";
import { useAuthState } from 'react-firebase-hooks/auth';
import { QueryClient, QueryClientProvider } from 'react-query';
import {Route, Routes, useSearchParams} from "react-router-dom";
import './App.css';
import AppLoadingAnimation from './components/AppLoadingAnimation';
import { auth } from './firebase';
import {signInWithCustomToken} from "firebase/auth";
import BoardScreen from "./screens/BoardScreen";
import Dashboard from './screens/Dashboard';
import Login from './screens/Login';
import LoginQR from "./components/LoginQR";
import Rsvp from "./screens/Rsvp";


const queryClient = new QueryClient()

function App() {
  const [user, userLoading] = useAuthState(auth);
  const [loginLoading, setLoginLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();


  const loginToken = searchParams.get("token");
  const doLogin = async () => {
      setLoginLoading(true);
      await signInWithCustomToken(auth,  loginToken);
      setLoginLoading(false);
  }
  useEffect(() => {
      if (loginToken) {
          doLogin();
      }
  }, [loginToken])


    const view = useCallback(() => {
        if (userLoading) {
            return <LoadingOverlay visible={true}/>
        }
        if (!user && !userLoading) {
            return <Login/>
        }

        if (searchParams.get("rsvp")) {
            return <Rsvp/>
        }
        return (
            <Routes>
                <Route path={"/"}>
                    <Route path={"/dashboard"} element={<Dashboard />}/>
                    <Route path="/:subdomain" element={<BoardScreen />} />
                    <Route index element={<Dashboard />}/>

                </Route>
            </Routes>
        )

    }, [userLoading, user])()

    if(userLoading || loginLoading) {
        return <LoadingOverlay visible={userLoading} loader={<AppLoadingAnimation/>}/>
    }



  return (
        <MantineProvider emotionOptions={{ prepend: false, key: 'picboard' }} withGlobalStyles withNormalizeCSS>
              <QueryClientProvider client={queryClient}>
                  {view}
              </QueryClientProvider>
        </MantineProvider>
  );
}

export default App;
